import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Table,
  Button,
  Input,
  Pagination,
  PaginationItem,
  PaginationLink,
} from 'reactstrap';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import { getTemplateList, deleteTemplate } from './actions';
import ConfirmModal from '../NotesPage/components/ConfirmModal';
import { tokenSelector } from '../Main/reducer';
import NoNotes from '../NotesPage/components/NoNotes';
import { FormattedMessage } from 'react-intl';
import Wrapper from './components/Wrapper';

class TemplateList extends Component {
  state = {
    searchTerm: '',
    currentPage: 1,
    itemsPerPage: 10,
    isDeleteModalOpen: false,
    templateToDelete: null,
  };

  componentDidMount() {
    this.props.getTemplateList(this.props.token);
  }

  handleSearch = (e) => {
    this.setState({ searchTerm: e.target.value, currentPage: 1 });
  };

  toggleDeleteModal = (template = null) => {
    this.setState({
      isDeleteModalOpen: !this.state.isDeleteModalOpen,
      templateToDelete: template,
    });
  };

  handleDelete = () => {
    const { templateToDelete } = this.state;
    if (templateToDelete) {
      this.props.deleteTemplate(this.props.token, templateToDelete);
      this.toggleDeleteModal();
    }
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  renderPagination = (totalItems) => {
    const { currentPage, itemsPerPage } = this.state;
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    return (
      <Pagination
        style={{ marginTop: '20px', display: 'flex', justifyContent: 'center' }}
      >
        <PaginationItem disabled={currentPage === 1}>
          <PaginationLink
            previous
            onClick={() => this.handlePageChange(currentPage - 1)}
          />
        </PaginationItem>
        {Array.from({ length: totalPages }, (_, index) => (
          <PaginationItem active={index + 1 === currentPage} key={index}>
            <PaginationLink onClick={() => this.handlePageChange(index + 1)}>
              {index + 1}
            </PaginationLink>
          </PaginationItem>
        ))}
        <PaginationItem disabled={currentPage === totalPages}>
          <PaginationLink
            next
            onClick={() => this.handlePageChange(currentPage + 1)}
          />
        </PaginationItem>
      </Pagination>
    );
  };

  render() {
    const { templates, loading } = this.props;
    const { searchTerm, currentPage, itemsPerPage, isDeleteModalOpen } =
      this.state;

    const sortedTemplates = [...templates].sort(
      (a, b) => new Date(b.updated_at) - new Date(a.updated_at)
    );

    const filteredTemplates = sortedTemplates.filter(
      (t) =>
        t.command.toLowerCase().includes(searchTerm.toLowerCase()) ||
        t.output.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentTemplates = filteredTemplates.slice(
      indexOfFirstItem,
      indexOfLastItem
    );

    return (
      <BlockUi blocking={loading}>
        <div style={{ minHeight: '100vh' }}>
          <h1>Templates</h1>
          <Input
            type="text"
            placeholder="Search templates by command or output"
            value={searchTerm}
            onChange={this.handleSearch}
            style={{ marginBottom: '20px' }}
          />
          <Button
            color="primary"
            style={{ marginBottom: '20px' }}
            onClick={() => this.props.history.push('/add-edit-template/new')}
          >
            Create New Template
          </Button>
          {loading ? (
            <div
              style={{
                textAlign: 'center',
                padding: '2rem',
                minHeight: '200px',
              }}
            >
              Loading templates...
            </div>
          ) : filteredTemplates.length === 0 ? (
            <NoNotes>
              <img
                alt="no-templates"
                src={require('../../assets/no-notes.png')}
              />
              <h1>
                <FormattedMessage id="TemplatesPage.noTemplates.title" />
              </h1>
              <div>
                <p className="mb-0">
                  <FormattedMessage id="TemplatesPage.noTemplates.desc1" />
                </p>
                <p>
                  <FormattedMessage id="TemplatesPage.noTemplates.desc2" />
                </p>
              </div>
              <Button
                color="primary"
                onClick={() =>
                  this.props.history.push('/add-edit-template/new')
                }
              >
                <FormattedMessage id="TemplatesPage.addTemplate" />
              </Button>
            </NoNotes>
          ) : (
            <>
              <Wrapper>
                <div className="" style={{ overflowX: 'auto', width: '100%' }}>
                  <Table className="table-wrapper">
                    <thead>
                      <tr>
                        <th>Title (Command)</th>
                        <th>Content (Output)</th>
                        <th>Updated At</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentTemplates.map((template) => (
                        <tr key={template.id}>
                          <td style={{ minWidth: '150px' }}>
                            {template.command
                              ? template.command.length > 50
                                ? template.command.slice(0, 50) + '...'
                                : template.command
                              : 'N/A'}
                          </td>
                          <td style={{ minWidth: '200px' }}>
                            {template.output
                              ? template.output.length > 50
                                ? template.output.slice(0, 50) + '...'
                                : template.output
                              : 'N/A'}
                          </td>
                          <td style={{ minWidth: '120px' }}>
                            {new Date(template.updated_at).toLocaleString()}
                          </td>
                          <td style={{ minWidth: '180px' }}>
                            <Button
                              color="primary"
                              size="sm"
                              style={{
                                width: '80px',
                                marginRight: '10px',
                                marginBottom: '2px',
                              }}
                              onClick={() =>
                                this.props.history.push(
                                  `/add-edit-template/${template.id}`
                                )
                              }
                            >
                              Edit
                            </Button>
                            <Button
                              color="danger"
                              size="sm"
                              style={{ width: '80px', marginBottom: '2px' }}
                              onClick={() => this.toggleDeleteModal(template)}
                            >
                              Delete
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </Wrapper>
              {filteredTemplates.length > this.state.itemsPerPage &&
                this.renderPagination(filteredTemplates.length)}
            </>
          )}
          <ConfirmModal
            isOpen={isDeleteModalOpen}
            toggle={this.toggleDeleteModal}
            onConfirm={this.handleDelete}
            message="Are you sure you want to delete this template?"
          />
        </div>
      </BlockUi>
    );
  }
}

const mapStateToProps = (state) => ({
  templates: state.template.templates,
  loading: state.template.loading,
  token: tokenSelector(state),
});

const mapDispatchToProps = {
  getTemplateList,
  deleteTemplate,
};

export default connect(mapStateToProps, mapDispatchToProps)(TemplateList);
